import { n as e } from "./api-teaser.service-_FM23jXz.js";
import { QBtn as t, QDialog as n } from "quasar";
import { Fragment as r, computed as i, createBlock as a, createCommentVNode as o, createElementBlock as s, createVNode as c, defineAsyncComponent as l, defineComponent as u, onBeforeMount as d, openBlock as f, ref as p, unref as m, watch as h, withCtx as g } from "vue";
import { CardList as _ } from "@editor/ui-utils";
import { useI18n as v } from "vue-i18n";
//#endregion
//#region src/lang/index.ts
var y = {
	en: { apiTeaserList: {
		search: "Search for placement ID",
		brand: "Brand",
		isEnabled: "Active",
		externalId: "Placement ID",
		headerExternalId: "Placement IDs",
		headerChangedAt: "Last modified date",
		select: "Select API teaser"
	} },
	de: { apiTeaserList: {
		search: "Suchen nach Placement-ID",
		brand: "Marke",
		isEnabled: "Aktiv",
		externalId: "Placement-ID",
		headerExternalId: "Placement-IDs",
		headerChangedAt: "Änderungsdatum (last modified)",
		select: "API-Teaser auswählen"
	} }
}, b = [{
	path: "/api-teaser",
	children: [{
		path: "",
		name: "api_teaser_list",
		component: () => import("./api-teaser-list.view-CwrfDXXY.js"),
		meta: { requiredRight: "api-teasers:navigate" }
	}]
}], x = /* @__PURE__ */ u({
	__name: "api-teaser-list.selector",
	props: {
		modelValue: { default: "" },
		brand: { default: void 0 },
		disableBrand: {
			type: Boolean,
			default: !1
		},
		disable: {
			type: Boolean,
			default: !1
		}
	},
	emits: ["update:modelValue"],
	setup(u, { emit: y }) {
		let b = l(() => import("./api-teaser-list.view-CwrfDXXY.js")), x = u, S = y, { t: C } = v(), w = p(!1), T = p(), E = i(() => [{
			_id: T.value?._id ?? "",
			title: T.value?.externalId ?? ""
		}]), D = (e) => {
			T.value = e, S("update:modelValue", T.value?._id), w.value = !1;
		}, O = () => {
			T.value = void 0, S("update:modelValue", void 0);
		};
		return h(() => x.modelValue, async () => {
			x.modelValue ? T.value = await e(x.modelValue) : T.value = void 0;
		}), d(async () => {
			T.value = await e(x.modelValue);
		}), (e, i) => (f(), s(r, null, [
			T.value?._id ? o("", !0) : (f(), a(m(t), {
				key: 0,
				"text-color": "secondary",
				icon: "plus",
				color: "primary",
				class: "q-mr-sm bg-white",
				"data-qa": "api-teaser-select-button",
				label: m(C)("apiTeaserList.select"),
				outline: "",
				disable: u.disable,
				onClick: i[0] ||= (e) => w.value = !0
			}, null, 8, ["label", "disable"])),
			T.value?._id ? (f(), a(m(_), {
				key: 1,
				items: E.value,
				disable: u.disable,
				onRemoveItem: O
			}, null, 8, ["items", "disable"])) : o("", !0),
			c(m(n), {
				"model-value": w.value,
				"full-width": "",
				"full-height": "",
				onHide: i[3] ||= (e) => w.value = !1
			}, {
				default: g(() => [c(m(b), {
					brand: u.brand,
					"disable-brand": u.disableBrand,
					dialog: !0,
					selection: "none",
					"onClick:apiTeaser": D,
					onClose: i[1] ||= (e) => w.value = !1,
					"onBack:modal": i[2] ||= (e) => w.value = !1
				}, null, 8, ["brand", "disable-brand"])]),
				_: 1
			}, 8, ["model-value"])
		], 64));
	}
}), S = {
	messages: y,
	routes: b
};
//#endregion
export { x as ApiTeaserListSelector, S as apiTeaserModule };

//# sourceMappingURL=index.es.js.map